interface ExpandArrowIconProps extends React.ComponentPropsWithoutRef<'svg'> {
  color?: string;
}

export function ExpandArrowIcon({ color = 'currentColor', ...svgProps }: ExpandArrowIconProps) {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.8011 5.38414C8.52564 5.40317 8.28708 5.19555 8.268 4.92011C8.24897 4.64465 8.4566 4.40609 8.73204 4.38701L12.53 4.12461C12.6742 4.11464 12.8158 4.16737 12.9181 4.26962C13.0096 4.3612 13.0615 4.48432 13.0642 4.61266C13.067 4.65353 13.0649 4.69468 13.0577 4.73512L12.8007 8.45564L12.7841 8.55508C12.722 8.77936 12.5088 8.93634 12.2676 8.91968C12.0264 8.90298 11.8369 8.71812 11.8063 8.4874L11.8035 8.38659L11.9717 5.94796L5.724 12.1956L8.17905 12.0264C8.45451 12.0073 8.69307 12.215 8.71214 12.4904C8.73117 12.7659 8.52355 13.0044 8.2481 13.0235L4.45017 13.2859C4.30591 13.2959 4.16433 13.2431 4.06209 13.1409C3.95984 13.0386 3.90711 12.8971 3.91707 12.7528L4.17948 8.95487L4.19605 8.85544C4.25813 8.63115 4.47139 8.47417 4.71257 8.49083C4.95375 8.50754 5.14324 8.69239 5.17385 8.92311L5.17661 9.02393L5.00591 11.4995L11.2931 5.21232L8.8011 5.38414Z"
        fill={color}
      />
    </svg>
  );
}
